import type { Agent } from '@atproto/api'
import { MACKINAC_SERVICE_DID } from '@/constants/api'

export async function getServiceAuthToken(agent: Agent, lxm: string): Promise<string> {
    const { data } = await agent.com.atproto.server.getServiceAuth({
        aud: MACKINAC_SERVICE_DID,
        lxm,
    })
    return data.token
}
